import React, { useState, useEffect } from 'react';
import TopicCard from './TopicCard';
import { Container, Row, Col, Navbar} from "shards-react";
import Clock from "./Clock";
// import Navbar from 'react-bootstrap/Navbar'

// import PageTitle from "./../components/common/PageTitle";
import PageTitle from "../common/PageTitle"

const axios = require('axios').default;

export default function TopicsOverviewSepetember() {
  const [data, setData] = useState([]);
  function compareTopicId(a, b) {
    if (a.topic_number > b.topic_number) return -1;
    if (b.topic_number > a.topic_number) return 1;

    return 0;
  }

  useEffect(() => {
    axios.get('topicsData.json') // topicsData.json
      .then(response => {

        response.data.sort(compareTopicId);
       
        

        setData(response.data);
      })
  }, []);

  return (
    <Container fluid className="main-content-container" style={{ maxWidth: '100%' }}>  
 

        <Row noGutters className="page-header">
        
          <PageTitle title={<h3 class="text-white">Real-Time Tracking of 2020 Election Disinformation - Sepetember</h3> }
                      subtitle={<h6>
                        <a target="_blank" class="text-warning " href="http://project-echo.ucdavis.edu">&laquo; Back to Project ECHO Home Page </a>
                        <a target="_blank" class="text-warning " href="http://34.209.246.203/january"> | January </a>
                        <a target="_blank" class="text-warning " href="http://34.209.246.203/december"> | December </a>
                        <a target="_blank" class="text-warning " href="http://34.209.246.203/november"> | November </a>
                        <a target="_blank" class="text-warning " href="http://34.209.246.203/october"> | October </a>
                        <a target="_blank" class="text-warning " href="http://34.209.246.203/september"> | September </a>
                        <a target="_blank" class="text-warning " href="http://34.209.246.203/August"> | August </a>
                        <a target="_blank" class="text-warning " href="http://34.209.246.203/June-and-July"> | June and July </a>
                        <a target="_blank" class="text-warning " href="http://34.209.246.203/topics-table"> | Got Bots?</a>
                      
                      </h6> }
                      className="text-sm-left text-warning" />

        </Row>

        <p class="text-sm-left text-white">Each disinformation topic includes three sets of charts: a Seismograph that monitors live Twitter activities on the topic, 
        a set of Influencer Bar Charts that show time top influencers appear and 
        the likelihood an influencer is a Twitter bot, and a Social Diagram 
        which maps out user interactions including those who are spreading the disinformation 
        and those who are trying to debunk it. According to Botometer, 
        Bot scores(Botness) are displayed on a 0-to-5 scale with zero being most human-like and five being the most bot-like. 
        Botometer’s Complete Automation Probability (CAP) is the probability that an account with bot scores or greater is controlled by software, i.e., is a bot.</p>

        <Row>
          <Clock />
        </Row>

      {data && data.slice(-50,-33).map((topicData) =>
        <Row key={topicData.title}>
          <Col className="py-4"><TopicCard data={topicData} /></Col>
        </Row>
      )}

      
    </Container>



  )
}





